import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'Synthetic Monitoring',
  slug: 'synthetic-monitoring',
  definition: `Synthetic monitoring uses automated scripts or requests to simulate user interactions with your service. Instead of waiting for real users to encounter problems, synthetic monitors proactively check your endpoints on a fixed schedule.

The simplest form of synthetic monitoring is an HTTP check — a request sent to your endpoint every N seconds to verify it responds correctly. More advanced forms include multi-step API checks, browser-based transaction monitoring, and scripted user flows.

Synthetic monitoring is called "synthetic" because the traffic is artificial. It complements real user monitoring (RUM) by providing consistent, baseline measurements that are not affected by user behavior or traffic volume.`,
  whyItMatters: `Synthetic monitoring catches problems before users do. If your service goes down at 3 AM when traffic is low, synthetic monitors detect it immediately while real user monitoring might not notice for hours.

It also provides consistent performance baselines. Since synthetic checks run the same request at fixed intervals, you can compare response times across days and weeks without the noise of varying user behavior.`,
  howUptrackHelps: `Uptrack is a synthetic monitoring platform at its core. Every monitor sends HTTP/HTTPS requests to your endpoints at 30-second or 1-minute intervals, verifying availability and measuring response times.

Confirmation checks ensure that transient failures do not trigger false alerts. Only confirmed outages generate notifications, giving you reliable signal without noise.`,
  relatedTerms: [
    { name: 'Real User Monitoring', href: '/glossary/real-user-monitoring' },
    { name: 'Latency', href: '/glossary/latency' },
    { name: 'Uptime', href: '/glossary/uptime' },
    { name: 'MTTD', href: '/glossary/mttd' },
  ],
}

export const Route = createFileRoute('/_site/glossary/synthetic-monitoring')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
